<template>
  <div>
    <ihead :checkindex="checkindex"></ihead>
    <div class="banner-box">
      <h1>{{ title }}</h1>
    </div>
    <mu-container v-if="id < 29 || id > 31">
      <mu-breadcrumbs>
        <mu-breadcrumbs-item
          v-for="(item, index) in items"
          :key="index"
          :to="item.to"
          :disabled="item.disabled"
          >{{ item.text }}</mu-breadcrumbs-item
        >
      </mu-breadcrumbs>
    </mu-container>
    <imgtext :detailList="detailList" :judgeList="judgeList"></imgtext>
    <ifoot></ifoot>
    <returntop class="return-top"></returntop>
  </div>
</template>

<script>
import ihead from "@/components/ihead.vue";
import ifoot from "@/components/ifoot.vue";
import crumbs from "@/components/crumbs.vue";
import returntop from "@/components/returntop";
import imgtext from "@/components/article_detail";

export default {
  components: {
  ihead,
  ifoot,
  crumbs,
  returntop,
  imgtext
  },
  data() {
    return {
      title: "",
      id: this.$route.query.id,
      mainid: this.$route.query.mainid,
      subid: this.$route.query.subid,
      checkindex: 6,
      items: [
        {
          text: "首页",
          to: "/",
          disabled: false
        },
        {
          text: "",
          disabled: true
        },
        {
          text: "",
          disabled: true
        }
      ],
      judgeList: { key: false },
      detailList: ""
    };
  },
  watch: {
    $route(to, from) {
      this.id = to.query.id
      this.subid = to.query.subid
      this.getDetailList()
      this.getNav()
    }
  },
  created() {
    this.getDetailList()
    this.getNav()
  },
  methods: {
    getId(key, url) {
      return this.$getSearchString(key, url);
    },
    getDetailList(id) {
      let data = {
        id: this.id
      };
      this.$get("/article/get-article-detail", data).then(res => {
        if (res.code == 0) {
          this.detailList = res.data.content;
        } else {
          // console.log(res.message);
        }
      });
    },
    getNav() {
      this.$get("/nav/get-nav-tree").then(res => {
        if (res.code === 0) {
          let data = res.data;          
          if (data) {
            let newData = data.filter((item, index, array) => {              
              return item.id === this.mainid;
            }); 
            this.$set(this.items[1], "text", newData[0].text);            
            if (newData[0].children) {
              let subData = newData[0].children;
              let newSubData = subData.filter((item, index, array) => {
                return item.id === this.subid;
              });
              this.$set(this.items[2], "text", newSubData[0].text);
              this.title = newSubData[0].text;
            }
          }
        } else {
          // console.log(res.message);
        }
      })
    }
  }
};
</script>

<style>
@media screen and ( max-width: 768px){
  .introduction-content{
    margin: 0 15px;
  }
	.warp p img {
    width: 100%;
    height: 200px;
  }
}
@media screen and ( max-width: 320px) {			
}
</style>
